import {fetchPost} from "../../utils/fetch";

/**
 * お気に入り切り替え（追加、削除）
 */
const toggleFavorite = ({
                             goods_code,
                             callSuccess = () => {},
                             callError = () => {},
                             callFinally = () => {},
                           }) => {
  fetchPost({
    action: "/api/favo/toggle",
    data: {
      goods_code: goods_code,
    },
  })
    .then((data) => {
      callSuccess(data);
    })
    .catch((reason) => {
      // error
      callError(reason);
    })
    .finally(() => {
      // finally
      callFinally();
    });
}

export default toggleFavorite;